export const StarBoldOutlineFilled = () => (
  <svg width="41" height="38" viewBox="0 0 41 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.368 1.54054L13.5055 11.278L2.50877 12.8155C0.563774 13.1084 -0.184302 15.4512 1.23704 16.8423L9.09184 24.3833L7.22165 34.9994C6.92242 36.9029 9.01703 38.3672 10.7376 37.4887L20.5374 32.4369L30.2624 37.4887C31.983 38.3672 34.0776 36.9029 33.7784 34.9994L31.9082 24.3833L39.763 16.8423C41.1843 15.4512 40.4362 13.1084 38.4912 12.8155L27.5693 11.278L22.632 1.54054C21.8091 -0.14338 19.2657 -0.216594 18.368 1.54054Z"
      fill="#292B29"
    />
  </svg>
);
